export enum EmitterEvents {
  DiffUpdates = '[Emitter] DIFF_UPDATES',
}
